import styled from 'styled-components';

import { Link } from 'react-router-dom';

import React from 'react';

const InfoLinkContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin-top: 10px;
`;

const InfoLink = styled(Link)<{ $light: boolean }>`
  font-size: 18px;
  padding-bottom: 4px;
  padding-right: 5px;
  text-decoration-line: underline;
  color: ${(props) => (props.$light ? props.theme.colors.linkColorLight : props.theme.colors.linkColorDark)};
`;

const MoreInformationLink = ({ text, to, light }: { text: string; to: string; light: boolean }) => (
  <InfoLinkContainer>
    <InfoLink $light={light} to={to}>
      {text}
    </InfoLink>
  </InfoLinkContainer>
);

export default MoreInformationLink;



// WEBPACK FOOTER //
// ./packages/smart-home-support/assets/components/ValuePropositionLink.tsx